import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Container,
  Typography,
  Grid,
  Button,
} from "@material-ui/core";
import FaqData from "src/component/FaqData";
import { Link } from "react-router-dom";
import axios from "axios";
import Apiconfig from "src/ApiConfig/ApiConfig";
import ButtonCircularProgress from "src/component/ButtonCircularProgress";
import DataNotFound from "src/component/DataNotFound";
import { AnimationOnScroll } from "react-animation-on-scroll";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "75px 0 30px",
    [theme.breakpoints.down("xs")]: {
      padding: "50px 0",
    },
    "& h1": {
      // fontSize: "30px",
      fontFamily: "'ClashDisplay-Extralight'",

      "& span": { fontFamily: "'ClashDisplay-Medium'" },

      "& img": {
        marginRight: "20px",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "20px",
      },
    },
  },
}));

function Faq() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [userlist, setuserlist] = useState([]);
  const [expandedAccordion, setExpandedAccordion] = useState(0);
  const handleAccordionChange = (index) => {
    setExpandedAccordion(index === expandedAccordion ? null : index);
  };

  const FaqdataApi = async () => {
    try {
      setIsLoading(true);
      await axios.get(Apiconfig.faqList).then(async (res) => {
        if (res.data.statusCode == 200) {
          setuserlist(res.data.result);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      });
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };
  useEffect(() => {
    FaqdataApi();
  }, []);
  return (
    <>
      <Box className={classes.root}>
        <Container maxWidth="lg">
          <AnimationOnScroll animateIn="animate__bounceInLeft">
            <Typography variant="h1" color="primary">
              Frequently Asked{" "}
              <span style={{ fontWeight: "600" }}> Questions </span>
            </Typography>
          </AnimationOnScroll>
          <Box mt={4}>
            <Grid container spacing={1}>
              {isLoading ? (
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <ButtonCircularProgress />
                </Box>
              ) : (
                <>
                  {userlist.slice(0, 4).map((data, i) => {
                    return (
                      <Grid item xs={12} sm={12} md={12} key={i}>
                        <FaqData
                          data={data}
                          index={i}
                          expandedAccordion={expandedAccordion}
                          handleAccordionChange={handleAccordionChange}
                        />
                      </Grid>
                    );
                  })}
                </>
              )}
              {!isLoading && userlist && userlist?.length === 0 && (
                <DataNotFound />
              )}
            </Grid>
          </Box>
          <Box align="right" mt={2}>
            {userlist && userlist?.slice(0, 4).length >= 4 && (
              <Button
                variant="contained"
                size="large"
                color="primary"
                component={Link}
                to="/faqs"
                className={classes.buttonright}
              >
                View More
              </Button>
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
}
export default Faq;
